/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Turnstile_UnavailableInputs */

const en_turnstile_unavailable = /** @type {(inputs: Turnstile_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We can't check that you're a person right now, so signing in isn't possible. Try again in a few minutes.`)
};

/**
* | output |
* | --- |
* | "We can't check that you're a person right now, so signing in isn't possible. Try again in a few minutes." |
*
* @param {Turnstile_UnavailableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const turnstile_unavailable = /** @type {((inputs?: Turnstile_UnavailableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Turnstile_UnavailableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_turnstile_unavailable(inputs)
});